import { Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import useSecurity from '../../hooks/useSecurity/useSecurity';
import useStyles from '../../styles/useStyles';
import DGManagement from './components/DGManagement/DGManagement';
import PlaceholderManagementGrid from './components/PlaceholderManagement/PlaceholderManagementGrid';

const ConfigurationDocumentPlaceholder: React.FC = () => {
    const classes = useStyles();

    const [openedDGManagement, setOpenedDGManagement] = useState(false);
    const { canManage } = useSecurity();

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column' }}>
            {canManage() && (
                <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                    <Grid item xs={2} style={{ display: 'flex', flexDirection: 'row' }}>
                        <Grid item>
                            <Button
                                className={classes.addNewFolderButton}
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={() => setOpenedDGManagement(!openedDGManagement)}
                            >
                                DG Management
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            <Grid item xs={12} className={classes.syncLogsGrid}>
                <PlaceholderManagementGrid />
            </Grid>
            {openedDGManagement && (
                <DGManagement openedDGManagement={openedDGManagement} setOpenedDGManagement={setOpenedDGManagement} />
            )}
        </Grid>
    );
};

export default ConfigurationDocumentPlaceholder;
